module.exports = __webpack_public_path__ + "img/scan.535daeaf.png";